import SectionLabel from "./SectionLabel";

export default function HomeSelectedWork() {
  return (
    <section
      id="selected-work"
      className="av-section av-work"
      aria-labelledby="av-work-title"
      data-testid="selected-work-section"
    >
      <div className="av-shell av-split">
        <div>
          <SectionLabel>Case studies</SectionLabel>
          <h2 id="av-work-title">Technology applied to operating priorities.</h2>
        </div>
        <article className="av-case-note">
          <figure className="av-case-note-image">
            <img
              src="/case-studies/healthcare-lab.jpg"
              alt="Diagnostic laboratory technician operating analysis equipment"
            />
          </figure>
          <div className="av-case-meta">
            <span>Healthcare operations</span>
            <span>Voice operations</span>
          </div>
          <h3>
            Voice agents for a diagnostics chain.
          </h3>
          <p>
            A 24/7 voice agent handling roughly 2,000 calls a day in Hindi,
            English and Bengali: home-collection and outpatient bookings,
            test-report queries and general queries, with 72% resolved without
            a human.
          </p>
          <p className="av-case-status">Case study · Live in production</p>
          <a className="av-text-link" href="/work/diagnostics-voice-agent">
            Read the case study <span aria-hidden="true">→</span>
          </a>
        </article>
      </div>
    </section>
  );
}
